import { createContext, useContext } from "react";
import { useStoreWithEqualityFn } from "zustand/traditional";

import type { FeatureIslandCategoryManagerStore, FeatureIslandCategoryManagerStoreType } from "../store";

export const FeatureIslandCategoryManagerContext = createContext<FeatureIslandCategoryManagerStore | null>(null);

export const useFeatureIslandCategoryManagerContext = <T>(
	selector: (state: FeatureIslandCategoryManagerStoreType) => T,
	equalityFn?: (left: T, right: T) => boolean,
) => {
	const featureIslandCategoryManager = useContext(FeatureIslandCategoryManagerContext);

	if (!featureIslandCategoryManager) {
		throw new Error("FeatureIslandCategoryManagerContext is not defined");
	}

	return useStoreWithEqualityFn(featureIslandCategoryManager, selector, equalityFn);
};
